export enum SpecialDayEnum {
  HAPPY_BIRTHDAY = 'Happy birthday',
  LUNAR_NEW_YEAR = 'Lunar New Year',
  SONGKRAN = 'Songkran',
  HALLOWEEN = 'Halloween',
  LOY_KRATHONG = 'Loy Krathong',
  CHRISTMAS_AND_HNY = 'Christmas & HNY',
}
